// extracted by mini-css-extract-plugin
export default {"customForm":"ape-Form_customForm__ogk-Z"};